var getNative = require('./_getNative'),
    root = require('./_root');

/* Built-in method references that are verified to be native. */
var Set = getNative(root, 'Set');

module.exports = Set;



//////////////////
// WEBPACK FOOTER
// ./~/victory-box-plot/~/lodash/_Set.js
// module id = ./node_modules/victory-box-plot/node_modules/lodash/_Set.js
// module chunks = 1